import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/r/$slug")({
  head: () => ({
    meta: [{ title: "Receipt · Glider" }],
  }),
});
